import * as React from 'react';
const SvgDataViz = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={120}
    height={120}
    fill="none"
    viewBox="0 0 120 120"
    {...props}
  >
    <circle cx={60} cy={60} r={60} fill="#E6F1FF" />
    <path
      fill="#003DE4"
      d="M37.5 24h-15v72h15zM57.5 55.5h-15V96h15zM62.5 37.5h15V96h-15zM97.5 69h-15v27h15z"
    />
    <mask
      id="a"
      width={76}
      height={72}
      x={22}
      y={24}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill="#003DE4"
        d="M37.5 24h-15v72h15zM57.5 55.5h-15V96h15zM62.5 37.5h15V96h-15zM97.5 69h-15v27h15z"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#5EA8FF"
        d="M82.5 63h15v24h-15zM60.75 32.25h18v34.5h-18zM41.25 32.25h18V75h-18zM21 17.25h18V60H21z"
      />
      <path
        fill="#fff"
        d="M21 18h18v23.25H21zM41.25 32.25h18V60h-18zM60.75 32.25h18V55.5h-18zM82.5 63h15v12h-15z"
      />
    </g>
    <path fill="#0600A6" d="M21 96h78v1.5H21z" />
    <circle cx={11.596} cy={57} r={1.5} fill="#5EA8FF" />
    <circle cx={93.75} cy={52.5} r={1.5} fill="#003DE4" />
    <path
      fill="#CCE7FF"
      d="M59.003 11.24c.266-.987 1.728-.987 1.994 0l.14.518c.096.358.393.635.77.716l.29.063a.98.98 0 0 1 0 1.926l-.29.063a1.01 1.01 0 0 0-.77.716l-.14.518c-.266.987-1.728.987-1.994 0l-.14-.518a1.01 1.01 0 0 0-.77-.716l-.29-.063a.98.98 0 0 1 0-1.926l.29-.063c.377-.082.674-.358.77-.716z"
    />
    <circle cx={90.75} cy={29.654} r={2.25} fill="#5EA8FF" />
    <path
      fill="#126CFB"
      d="M97.754 34.676c.333-1.235 2.16-1.235 2.492 0l.174.646c.121.448.493.794.964.895l.362.079a1.224 1.224 0 0 1 0 2.408l-.362.079a1.26 1.26 0 0 0-.964.895l-.174.647c-.332 1.233-2.16 1.233-2.492 0l-.174-.647a1.26 1.26 0 0 0-.963-.895l-.363-.079a1.224 1.224 0 0 1 0-2.408l.363-.079c.47-.101.842-.447.963-.895z"
    />
  </svg>
);
export default SvgDataViz;
